var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5043 12.769C12.0565 13.0676 11.5363 13.2254 11 13.2254C10.4637 13.2254 9.94355 13.0676 9.49573 12.769L2.11985 7.85161C2.07893 7.82433 2.03906 7.79589 2 7.76664V15.8243C2 16.7482 2.74971 17.4814 3.65702 17.4814H18.3429C19.2668 17.4814 20 16.7317 20 15.8243V7.7666C19.9608 7.79592 19.9209 7.82443 19.8799 7.85175L12.5043 12.769Z",
    fill: "#62656D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70488 6.97394L10.0808 11.8914C10.36 12.0775 10.68 12.1706 11 12.1706C11.32 12.1706 11.64 12.0775 11.9192 11.8914L19.2951 6.97394C19.7365 6.67986 20 6.18767 20 5.65646C20 4.74306 19.2569 4 18.3435 4H3.65646C2.7431 4.00004 2 4.7431 2 5.65734C2 6.18767 2.26353 6.67986 2.70488 6.97394Z",
    fill: "#62656D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.55b81b3b3c6e86f5e2229e89f108003c.svg";
export { ForwardRef as ReactComponent };